<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_sku_search') ||
                  'SKU编号/NC/产品名称/颜色/客户/品牌/品类/系列 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-drawer
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      show-close
      :visible.sync="advqueryDialogVisible"
      size="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="ml-4 mr-4">
        <el-form
          ref="form"
          :model="form"
          label-width="100px"
          label-position="right"
          size="mini"
        >
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$l('form_label_advquery_no') || 'SKU编号'">
                <el-input
                  v-model.trim="form.evgSkuNo"
                  :placeholder="
                    $l('form_placeholder_advquery_no') || '请输入SKU编号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_spu_no') || 'SPU编号'"
              >
                <el-input
                  v-model.trim="form.evgSpuNo"
                  :placeholder="
                    $l('form_placeholder_advquery_spu_no') || '请输入SPU编号'
                  "
                  size="mini"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_eanCode') || 'EAN条码'"
              >
                <el-input
                  v-model.trim="form.eanCode"
                  :placeholder="
                    $l('form_placeholder_advquery_eanCode') || '请输入EAN条码'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_advquery_ncNo') || 'NC编号'">
                <el-input
                  v-model.trim="form.ncNo"
                  :placeholder="
                    $l('form_placeholder_advquery_ncNo') || '请输入NC编号'
                  "
                  size="mini"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_goodsNameCn') || '中文名称'"
              >
                <el-input
                  v-model.trim="form.goodsName"
                  :placeholder="
                    $l('form_placeholder_sku_goodsNameCn') || '请输入中文名称'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_goodsNameEn') || '英文名称'"
              >
                <el-input
                  v-model.trim="form.goodsNameEn"
                  :placeholder="
                    $l('form_placeholder_advquery_goodsNameEn') ||
                      '请输入英文名称'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_advquery_cust') || '客户'">
                <dict-select
                  v-model="form.custCode"
                  url="/ecom/ecom/evg/spu/customerFormalSelect"
                  :placeholder="
                    $l('form_placeholder_advquery_cust') || '请选择客户'
                  "
                  filterable
                  clearable
                  size="mini"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_advquery_brand') || '品牌'">
                <dict-select
                  v-model="form.listBrandCode"
                  url="/master/common/dict/brandSelect"
                  :placeholder="
                    $l('form_placeholder_advquery_brand') || '请选择品牌'
                  "
                  clearable
                  filterable
                  multiple
                  size="mini"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_succession') || '系列'"
              >
                <dict-select
                  v-model="form.listCollectionNo"
                  url="/master/common/dict/biz"
                  :placeholder="
                    $l('form_placeholder_advquery_selectseries') || '请选择系列'
                  "
                  :body="collectionParams"
                  clearable
                  filterable
                  multiple
                  size="mini"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_category') || '品类'"
              >
                <el-cascader
                  :options="categoryTree"
                  :props="{
                    emitPath: false,
                    checkStrictly: false,
                    value: 'value',
                    label: 'label',
                  }"
                  ref="cascaderCategoryTreeRef"
                  v-model="form.detailCategoryCode"
                  clearable
                  filterable
                  style="width: 100%"
                  :showAllLevels="false"
                  @change="onCategoryChange"
                  :placeholder="
                    $l('form_placeholder_advquery_category') || '请选择品类'
                  "
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.label }}</span>
                    <span v-if="!node.isLeaf">
                      ({{ data.children.length }})
                    </span>
                  </template>
                </el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_goodsColorCn') || '中文颜色'"
              >
                <el-input
                  v-model.trim="form.goodsColor"
                  :placeholder="
                    $l('form_placeholder_advquery_goodsColorCn') ||
                      '请输入中文颜色'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_goodsColorEn') || '英文颜色'"
              >
                <el-input
                  v-model.trim="form.goodsColorEn"
                  :placeholder="
                    $l('form_placeholder_advquery_goodsColorEn') ||
                      '请输入英文颜色'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_goods_pattern') || '花型'"
              >
                <el-input
                  v-model.trim="form.goodsPattern"
                  :placeholder="
                    $l('form_placeholder_advquery_goods_pattern') ||
                      '请输入花型'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_goods_style') || '款式'"
              >
                <el-input
                  v-model.trim="form.goodsStyle"
                  :placeholder="
                    $l('form_placeholder_advquery_goods_style') || '请输入款式'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_scm') || '生产工厂'"
              >
                <dict-select
                  v-model="form.scmCode"
                  url="/master/common/dict/scmPartners"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :placeholder="
                    $l('form_placeholder_advquery_scm') || '请选择生产工厂'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="10">
                <el-form-item
                  :label="$l('form_label_advquery_createDate') || '创建时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateStart"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('form_placeholder_advquery_create_start_date') ||
                          '选择日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateEnd"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('form_placeholder_advquery_create_end_date') ||
                          '选择日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="10">
                <el-form-item
                  :label="$l('form_label_advquery_modifyDate') || '修改时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateStart"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('form_placeholder_advquery_modify_start_date') ||
                          '选择日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateEnd"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('form_placeholder_advquery_modify_end_date') ||
                          '选择日期'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_createBy') || '创建人'"
                prop="createBy"
              >
                <dict-select
                  v-model="form.createBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_placeholder_advquery_createBy') || '请选择创建人'
                  "
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_advquery_modifyBy') || '修改人'"
                prop="modifyBy"
              >
                <dict-select
                  v-model="form.modifyBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_placeholder_advquery_modifyBy') || '请选择修改人'
                  "
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="dialog-footer mb-4 mt-2 d-flex  justify-content-end">
          <el-button size="mini" @click="closeAdvqueryDialog">
            {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
          </el-button>
          <el-button size="mini" type="warning" @click="reset">
            {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
          </el-button>
          <el-button size="mini" type="primary" @click="advquery">
            {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listNeedInspection: [],
  listEvgSkuStatus: ['Q'],
  listIsVc: [],
  listApplicationStatus: ['P'],
}
export default {
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      masterCategoryParams: { parentCode: 'ABSHome' },
      collectionParams: { dictType: 'skuCollection' },
      categoryTree: [],
    }
  },
  mounted() {
    this.query()
    this.getTreeData()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi(this.masterCategoryParams)
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    onCategoryChange() {
      const nodes = this.$refs.cascaderCategoryTreeRef.getCheckedNodes()
      if (nodes?.length && nodes[0] && nodes[0].path?.length) {
        this.formData.displayCategoryCode = nodes[0].path.join(',')
        this.formData.masterCategoryCode = nodes[0].path[0]
      } else {
        this.formData.displayCategoryCode = null
        this.formData.masterCategoryCode = null
      }
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
